import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'

import _ from 'lodash'

import Well from '@react/react-spectrum/Well'
import Button from '@react/react-spectrum/Button'
import { success } from '@react/react-spectrum/Toast'
import { Form, FormItem } from '@react/react-spectrum/Form'
import Textfield from '@react/react-spectrum/Textfield'
import Checkbox from '@react/react-spectrum/Checkbox'
import ComboBox from '@react/react-spectrum/ComboBox'
import Datepicker from '@react/react-spectrum/Datepicker'

import { RootContext } from '../../../root/RootContext'
import { ProfileContext } from '../../../root/ProfileContext'
import './ProfileUpdate.scss'
import { getProfileFieldValue } from '../../../config/lib.js'

export default function ProfileUpdate({ meta, content }) {
  const profileContext = useContext(ProfileContext)
  const rootContext = useContext(RootContext)
  const currentProfile = profileContext.state.currentProfile
  const tenantId = '_' + rootContext?.project?.integrations?.aep?.imsOrg?.tenantID

  const [values, setValues] = useState()

  const handleChange = (a, e) => {
    let newArray = [...values]
    newArray[a.idx] = { ...a, value: e }
    setValues(newArray)
  }

  useEffect(() => {
    if (currentProfile) {
      const n = content.attributes?.map((a, idx) => {
        let n = { ...a }
        const v = getProfileFieldValue(tenantId, currentProfile, a.name)
        n.value = v === '--' ? '' : v
        n.idx = idx

        return n
      })
      setValues(n)
    }
  }, [currentProfile])

  const handleClick = (e) => {
    const newValues = values.map((a) => {
      const cleanPath = a.name.replace(/\./g, '/').replace(/^entity/, '')
      return { op: 'add', path: cleanPath, value: a.value }
    })
    e.preventDefault()
    window.dispatchEvent(
      new CustomEvent('submitProfileUpdate', {
        detail: newValues,
      })
    )
    success('Profile attributes updated', {
      onClose: () => {},
      timeout: 4000,
    })
  }

  return (
    <div className='profile-module profile-update'>
      <div className='module-content'>
        {currentProfile && currentProfile.experienceEvents && (
          <div align='center'>
            {content.description && <Well>{content.description}</Well>}
            <Form aria-labelledby='form' className='profile-update form'>
              {values &&
                values.map((a, idx) => {
                  if (a.type === 'checkbox') {
                    return (
                      <FormItem key={idx} label={a.label} labelAlign='right'>
                        <Checkbox
                          defaultChecked={a.value == 'true' ? true : false}
                          key={a.name}
                          onChange={(e) => handleChange(a, e)}
                        />
                      </FormItem>
                    )
                  } else if (a.type === 'dropdown') {
                    return (
                      <FormItem key={idx} label={a.label} labelAlign='right'>
                        <ComboBox
                          value={a.value}
                          className='combo-box'
                          onSelect={(e) => handleChange(a, e)}
                          options={a.options.split(',').map((item) => item.trim())}
                          placeholder='Select Value'
                          quiet={true}
                          required={false}
                        />
                      </FormItem>
                    )
                  } else if (a.type === 'calendar') {
                    return (
                      <FormItem key={idx} label={a.label} labelAlign='right'>
                        <Datepicker
                          type='date'
                          value={a.value}
                          aria-label={a.label}
                          onChange={(e) => handleChange(a, e)}
                        />
                      </FormItem>
                    )
                  } else {
                    return (
                      <FormItem key={idx} label={a.label} labelAlign='right'>
                        <Textfield
                          value={a.value}
                          type={a.type}
                          name={a.name}
                          key={a.name}
                          className='form-textfield'
                          onChange={(e) => handleChange(a, e)}
                        />
                      </FormItem>
                    )
                  }
                })}

              <FormItem labelAlign='right'>
                <Button variant='primary' onClick={handleClick} name='submit' className='profile-update button'>
                  Submit
                </Button>
              </FormItem>
            </Form>
          </div>
        )}
      </div>
    </div>
  )
}

ProfileUpdate.requiresLaunch = true
